// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function DatapointsComparisonSpecificsComparatesFromJSON(json) {
    return {
        'id': json['id'],
        'alias': json['alias'],
    };
}
export function DatapointsComparisonSpecificsComparatesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'alias': value.alias,
    };
}
